import MuiCheckbox, { type CheckboxProps as MuiCheckboxProps } from '@material-ui/core/Checkbox';
import cx from 'classnames';

import { CheckboxChecked } from './assets/CheckboxChecked';
import { CheckboxDefault } from './assets/CheckboxDefault';
import { CheckboxIndeterminate } from './assets/CheckboxIndeterminate';
import { useStyles } from './useStyles';

interface CustomCheckboxProps extends MuiCheckboxProps {
  iconClassName?: string;
}

export const CustomCheckbox = ({ className, iconClassName, ...props }: CustomCheckboxProps) => {
  const styles = useStyles();

  return (
    <MuiCheckbox
      className={cx(styles.root, className)}
      classes={{
        colorPrimary: styles.colorPrimary,
        checked: styles.checked,
        disabled: styles.disabled,
      }}
      icon={<CheckboxDefault className={iconClassName} />}
      checkedIcon={<CheckboxChecked className={iconClassName} />}
      indeterminateIcon={<CheckboxIndeterminate className={iconClassName} />}
      color="primary"
      disableRipple
      {...props}
    />
  );
};
